import { omniOfferScopeOfWorkAddDialogConfig } from "@/services/backend/omni/servicekindrules/omni-offer-scope-of-work-add-dialog-config";
import { useOmniOfferShowQuery } from "@/services/backend/omni/offer/api/offer-api";
import { OfferScopeOfWorksPage } from "@/services/backend/omni/offer/components/offer-scope-of-works-page";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useParams } from "react-router";

export function OfferScopeOfWorksRoute() {
  const { offerId } = useParams();

  const { data, isLoading, error } = useOmniOfferShowQuery({
    id: offerId!,
  });

  return (
    <div>
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
      {data && (
        <OfferScopeOfWorksPage
          offer={data}
          addDialogConfig={omniOfferScopeOfWorkAddDialogConfig}
        />
      )}
    </div>
  );
}
